import { Box, Stack, Tab, Tabs, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react';
import JobRequests from './JobRequests';
import JobList, { Status } from './JobList';
import { Link } from '@mui/icons-material';
import { CustomButton } from '../../../../layout/styledcomponents/CustomButton';
import CalendarLinkModal from './CalendarLinkModal';
import {
    useGetIndividualContractorQuery,
    useGetProfileDetailsQuery,
} from '../../../../app/Slices/SevenDayApiSlice';
import UserRole from '../../../../shared/AuthRoles';
import { ContractorRole } from '../../../enums/users';

const Jobs = () => {
    const [tab, setTab] = useState<Status>('accepted');
    const loggedInUser = UserRole();

    const { data: contractor } = useGetIndividualContractorQuery(
        loggedInUser?.company,
        { skip: loggedInUser.role !== ContractorRole.Admin },
    );

    const { data: profileDetails } = useGetProfileDetailsQuery('/profile');

    const [calendarModalOpen, setCalendarModalOpen] = useState(false);
    const theme = useTheme();

    return (
        <>
            <Stack sx={{ pt: '30px', gap: 4 }}>
                <JobRequests />
                <div>
                    <Typography variant='subHeading'>Your Jobs</Typography>
                    <Stack spacing={1}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Tabs
                                value={tab}
                                onChange={(e, value) => setTab(value)}
                                variant='scrollable'
                                scrollButtons='auto'
                                sx={{ alignItems: 'flex-start' }}
                                TabIndicatorProps={{
                                    sx: {
                                        left: '8%',
                                        transform: 'translateX(-8%)',
                                        bottom: 0,
                                        borderRadius: '5px',
                                        backgroundColor:
                                            theme.palette.info.main,
                                        transition: 'all 150ms ease',
                                    },
                                }}
                            >
                                {[
                                    { value: 'accepted', label: 'Upcoming' },
                                    {
                                        value: 'pendingCompletion',
                                        label: 'Pending Completion',
                                    },
                                    { value: 'completed', label: 'Completed' },
                                    { value: 'declined', label: 'Declined' },
                                    { value: '', label: 'All' },
                                ].map(({ value, label }) => (
                                    <Tab
                                        key={value}
                                        value={value}
                                        label={
                                            <Box
                                                sx={{
                                                    textAlign: 'left',
                                                    width: '100%',
                                                }}
                                            >
                                                {label}
                                            </Box>
                                        }
                                        sx={{
                                            justifyContent: 'flex-start', // align label box left
                                            textTransform: 'none', // optional: keeps case
                                            minWidth: 'fit-content', // optional: shrink to fit
                                            paddingLeft: 0, // optional: removes left gutter
                                        }}
                                    />
                                ))}
                            </Tabs>
                            <CustomButton
                                color='primary'
                                size='large'
                                startIcon={
                                    <Link
                                        fontSize='small'
                                        sx={{ fontSize: '20px' }}
                                    />
                                }
                                onClick={() => setCalendarModalOpen(true)}
                            >
                                Calendar Link
                            </CustomButton>
                        </Box>
                        <JobList status={tab} />
                    </Stack>
                </div>
            </Stack>
            <CalendarLinkModal
                open={calendarModalOpen}
                onClose={() => setCalendarModalOpen(false)}
                contractorCalendarId={contractor?.calendarId ?? ''}
                userCalendarId={profileDetails?.calendarId ?? ''}
            />
        </>
    );
};

export default Jobs;
